<div class="patient-form-wrapper">
  <!-- photo -->
  <app-photo [image]="patientAvatar" [editable]="true" (imageReadyEvent)="setPatientAvatar($event)" *ngIf="!loadingAvatar"></app-photo>
  <!-- form -->
  <form [formGroup]="form" class="patient-form">
    <!-- firstname -->
    <app-form-input-text [field]="'firstname'" [formControl]="f['firstname']" formControlName="firstname"></app-form-input-text>
    <!-- lastname -->
    <app-form-input-text [field]="'lastname'" [formControl]="f['lastname']" formControlName="lastname"></app-form-input-text>
    <!-- dni/nie -->
    <app-form-input-text [field]="'nif'" [formControl]="f['taxcode']" formControlName="taxcode"
      (blurEvent)="checkTaxcode()"></app-form-input-text>
    <div class="cardholder-info">
      <!-- cardholder -->
      <div class="cardholder">
        <label [innerHTML]="'field.cardholder' | translate" class="input-label"></label>
        <p-selectbutton [options]="binaryOptions" formControlName="cardholder" optionLabel="name" optionValue="value"
          [allowEmpty]="false" />
      </div>
      <!-- cardholderEnd -->
      <app-form-input-date [field]="'cardholderEnd'" [formControl]="f['cardholderEnd']" formControlName="cardholderEnd"></app-form-input-date>
      <!-- discount -->
      <app-form-input-text-group [field]="'discount'" [formControl]="f['discount']" formControlName="discount"
        [postIcon]="'pi pi-percentage'" [label]="'field.discount' | translate" [number]="true" [decimals]="0"></app-form-input-text-group>
    </div>
    <p-message *ngIf="cardholderEndMsg" [severity]="cardholderEndSeverity" icon="pi pi-id-card">{{ cardholderEndMsg }}</p-message>
    <div class="phone-birthdate-rgpd">
      <!-- rgpd -->
      <div class="rgpd">
        <label [innerHTML]="'field.rgpd' | translate" class="input-label"></label>
        <p-selectbutton [options]="binaryOptions" formControlName="rgpd" optionLabel="name" optionValue="value" />
        <app-form-input-error 
          [show]="f['rgpd'].invalid && (f['rgpd'].dirty || f['rgpd'].touched)" 
          [required]="f['rgpd'].errors?.['required']"
        ></app-form-input-error>
      </div>
      <!-- birthdate -->
        <app-form-input-date [field]="'birthdate'" [formControl]="f['birthdate']" formControlName="birthdate"></app-form-input-date>
      <!-- phone -->
      <app-form-input-text-group [field]="'phone'" [formControl]="f['phone']" formControlName="phone"
        [pre]="'+34'" [preIcon]="'flag-icon flag-es'" [label]="'field.phone' | translate"></app-form-input-text-group>
    </div>
    <!-- email -->
    <app-form-input-text [field]="'email'" [formControl]="f['email']" formControlName="email"></app-form-input-text>
    <!-- address -->
    <app-form-input-text [field]="'address'" [formControl]="f['address']" formControlName="address"></app-form-input-text>
    <!-- city -->
    <app-form-input-text [field]="'city'" [formControl]="f['city']" formControlName="city"></app-form-input-text>
    <div>
      <!-- state -->
      <app-form-input-text [field]="'state'" [formControl]="f['state']" formControlName="state"></app-form-input-text>
      <!-- zipcode -->
      <app-form-input-text [field]="'zipcode'" [formControl]="f['zipcode']" formControlName="zipcode"></app-form-input-text>
    </div>
    <!-- tutorName -->
    <app-form-input-text [field]="'tutorName'" [formControl]="f['tutorName']" formControlName="tutorName"></app-form-input-text>
    <!-- tutorTaxcode -->
    <app-form-input-text [field]="'tutorTaxcode'" [formControl]="f['tutorTaxcode']" formControlName="tutorTaxcode"></app-form-input-text>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()" [disabled]="loadingTaxcode"/>
  </div>
</div>
